const data = {
    events:
    [
    {
        "id": 81,
        "event": "Maryland State Highway Administration archaeologists locate the cabin home of Ben Ross, Harriet Tubman's father.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 2021,
        "location": "Dorchester County, MD",
        "broaderLoc": [
            "Maryland"
        ],
        "affiliatedPrimarySourcesNameAndDescription": "Maryland Underground: Ben's 10 Part 2",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733302531?h=21e1746028\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Harriet Tubman, Now, Underground Railroad, Slavery",
        "sourceHyperlinkText": "MPT"
    },
    {
        "id": 80,
        "event": "The Maryland General Assembly dedicates life-sized statues of Harriet Tubman and Frederick Douglass in the Maryland State House, Old House chamber.",
        "importantPeopleAssociates": [
            "Harriet Tubman",
            "Frederick Douglass",
        ],
        "year": 2020,
        "location": "Annapolis, MD",
        "broaderLoc": [
            "Maryland"
        ],
        "affiliatedPrimarySourcesNameAndDescription": "Statues of Change | Maryland Public Television",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733302415?h=b6062443fa\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Harriet Tubman, Frederick Douglass, Now, Abolition, Slavery",
        "sourceHyperlinkText": "MPT"
    },
    {
        "id": 79,
        "event": "The Harriet Tubman Museum and Educational Center opens in Dorchester County, MD in 2017. The Center displays, literature, and videos about her life, slavery, and the Underground Railroad.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": "2010-2019",
        "location": "Dorchester County, MD",
        "broaderLoc": [
            "Maryland"
        ],
        "affiliatedPrimarySourcesNameAndDescription": "Harriet Tubman Underground Railroad State Park - Maryland Department of Natural Resources",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733310024?h=640d67314a\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Harriet Tubman, Now, Underground Railroad, Slavery, Abolition",
        "sourceHyperlinkText": "State of Maryland"
    },
    {
        "id": 78,
        "event": "In 2016, the US Treasury Department announces that Harriet Tubman will replace President Andrew Jackson on the $20 bill. ",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": "2010-2019",
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Harriet Tubman Replaces Andrew Jackson on $20 Bill | PBS NewsHour",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733302747?h=51d13fa017\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Culture, Now",
        "sourceHyperlinkText": "PBS LearningMedia"
    },
    {
        "id": 77,
        "event": "Barack Obama is elected the first mixed-race Black US president in 2008. He served two terms. The first African American First Lady, Michelle Obama, is a lawyer active in health and education. ",
        "importantPeopleAssociates": [
            "Harriet Tubman",
            "Frederick Douglass"
        ],
        "year": "2000-2009",
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "2009 Inaugural Parade. Michelle and Barack Obama",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/2010719315/",
        "topics": "Politics",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 76,
        "event": "Carol Moseley Braun from Illinois is elected the first African American woman to serve in the Senate in 1992.",
        "year": "1990-1999",
        "location": "Illinois, Washington, DC",
        "broaderLoc": ["Illinois", "Washington, DC"],
        "topics": "Politics"
    },
    {
        "id": 75,
        "event": "The Frederick Douglass National Historic Site opens in Washington, DC in 1988. Cedar Hill serves as the historic site and it was Douglass' home from 1877 until his death.",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": "1980-1989",
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Frederick Douglass House, 1411 W Street, Southeast, Washington, District of Columbia, DC",
        "affiliatedPrimarySourcesLink": "",
        "topics": "Frederick Douglass, Abolition, Slavery",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 74,
        "event": "President Richard Nixon resigns from office in 1974 because of his role in a political scandal called Watergate.",
        "year": "1970-1979",
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "topics": "Politics"
    },
    {
        "id": 73,
        "event": "The first Black Congresswoman, Shirley Chisholm, is also the first African-American woman to run for president in 1972. ",
        "importantPeopleAssociates": [
            "Harriet Tubman",
            "Frederick Douglass"
        ],
        "year": "1970-1979",
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Bring U.S. together. Vote Chisholm 1972, unbought and unbossed.",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/2014646807/",
        "topics": "Politics, Women's Rights",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 72,
        "event": "1964  President Lyndon Johnson signs The Civil Rights Act of 1964. The federal law ended segregation in public places and banned employment discrimination on the basis of race, color, religion, sex or national origin.",
        "importantPeopleAssociates": [
            "Harriet Tubman",
            "Frederick Douglass"
        ],
        "year": "1960-1969",
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Radio Coverage of President’s Johnson’s Remarks upon Signing the Civil Rights Act of 1964: The Complete Speech",
        "affiliatedPrimarySourcesLink": "<iframe src=\"//cdn.loc.gov/loader/embed/embed-with-loader.php?uuid=04ED995EED9006F2E0538C93F02806F2&size=mediumWide&metadata=Radio Coverage of President’s Johnson’s Remarks upon Signing the Civil Rights Act of 1964: The Complete SpeechENDLINE&image=&type=A\" width=\"943\" height=\"298\" frameborder=\"0\" scrolling=\"no\"></iframe>",
        "topics": "Civil Rights Act, Politics, Laws and Legal Cases"
    },
    {
        "id": 71,
        "event": "In 1954, the US Supreme Court rules in Brown v Board of Education that \"separate educational facilities (for blacks and whites) are...unequal\".  The ruling requires schools to legally desegregate.",
        "importantPeopleAssociates": [
            "Harriet Tubman",
            "Frederick Douglass"
        ],
        "year": "1950-1959",
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "School integration. Barnard School, Washington, D.C.",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/pictures/item/2003654384/",
        "topics": "Laws and Legal Cases, Politics",
        "sourceHyperlinkText": "LIbrary of Congress"
    },
    {
        "id": 70,
        "event": "The Tuskegee Airmen, the first African American US military pilots, fly combat aircraft in North Africa, Sicily and Italy during World War II in 1943. ",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": "1940-1949",
        "location": "Europe",
        "broaderLoc": ["Europe"],
        "affiliatedPrimarySourcesNameAndDescription": "[Photograph of several Tuskegee airmen at Ramitelli, Italy, March 1945]",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/ppmsca.13259/",
        "topics": "War",
        "sourceHyperlinkText": "LIbrary of Congress"
    },
    {
        "id": 69,
        "event": "World War II begins with the German invasion of Poland in 1939.",
        "year": "1930-1939",
        "location": "Europe",
        "broaderLoc": ["Europe"],
        "topics": "War"
    },
    {
        "id": 68,
        "event": "Franklin Roosevelt is elected as the 32nd President of the United States in 1932. He starts New Deal aide programs to support Americans during the Great Depression. ",
        "year": "1930-1939",
        "location": "Midwest",
        "broaderLoc": ["Midwest"],
        "affiliatedPrimarySourcesNameAndDescription": "FDR [Franklin Delano Roosevelt] IN CAR",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/hec.47235/",
        "topics": "Politics"
    },
    {
        "id": 67,
        "event": "The Harlem Renaissance begins in 1920. ",
        "year": "1920-1929",
        "location": "New York",
        "broaderLoc": ["New York"],
        "topics": "Culture"
    },
    {
        "id": 66,
        "event": "The 19th Amendment is ratified in 1920, giving women the right to vote. Women also enlist in the armed forces to support the U.S. in the Great War.",
        "importantPeopleAssociates": [
            "Harriet Tubman",
            "Susan B Anthony",
            "Elizabeth Cady Stanton"
        ],
        "year": "1920-1929",
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "The Bridgeport times and evening farmer., August 26, 1920",
        "affiliatedPrimarySourcesLink": "https://chroniclingamerica.loc.gov/lccn/sn92051227/1920-08-26/ed-1/seq-1/",
        "topics": "Suffrage, Women's Rights",
        "sourceHyperlinkText": "LIbrary of Congress"
    },
    {
        "id": 65,
        "event": "Germany invades European nations, and the U.S. joins other countries to ally against Germany. World War I begins in 1914. ",
        "year": "1910-1919",
        "location": "Europe",
        "broaderLoc": ["Europe"],
        "affiliatedPrimarySourcesNameAndDescription": "First Call! I need you in the Navy this minute! Our country will always be proudest of those who answered the first call.",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/2001699144/",
        "topics": "War"
    },
    {
        "id": 64,
        "event": "Harriet Tubman dies of pneumonia at age 91. She is buried with military honors.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1913,
        "location": "Auburn, NY",
        "broaderLoc": ["New York"],
        "affiliatedPrimarySourcesNameAndDescription": "HARRIET TUBMAN: VISIONS OF FREEDOM",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733302301?h=4c4165f369\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Life Events, Harriet Tubman",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 63,
        "event": "Henry Ford's Ford Motor Company introduces the Ford Model T.",
        "year": 1908,
        "location": "Detroit, MI",
        "broaderLoc": ["Michigan"],
        "topics": "Inventions"
    },
    {
        "id": 62,
        "event": "Harriet Tubman Home for Aged and Indigent Negroes opens.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1908,
        "location": "Auburn, NY",
        "broaderLoc": ["New York"],
        "affiliatedPrimarySourcesNameAndDescription": "Harriet Tubman Home for the Aged Front",
        "affiliatedPrimarySourcesLink": "https://www.nps.gov/media/photo/gallery-item.htm?pg=4954248&id=bfc267e5-1527-4fd0-b456-fc767b10cc05&gid=ACAAABB7-8101-46C1-8C2C-D3A5D4267664",
        "topics": "Life Events, Harriet Tubman",
        "sourceHyperlinkText": "National Park Service (NPS)"
    },
    {
        "id": 61,
        "event": "The U.S. declares war on Spain; the Spanish-American War begins.",
        "year": 1898,
        "location": "Havana Harbor",
        "broaderLoc": ["Cuba"],
        "topics": "War",
        "arrow": "east"
    },
    {
        "id": 60,
        "event": "Harriet Tubman gives speeches to support the women's suffrage movement.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1898,
        "location": "NY, MA, DC",
        "broaderLoc": ["New York", "Massachusetts", "Washington, DC"],
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733302257?h=45e02f08e1\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Suffrage, Women's Rights",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 59,
        "event": "The National Association of Colored Women’s Clubs is established. ",
        "importantPeopleAssociates": [
            "Mary Church Terrell",
            "Frances Ellen Watkins Harper"
        ],
        "year": 1896,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "National Association of Colored Women, 1897-1962",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/mss42549.mss42549-016_00247_00298/?sp=5&r=-0.262,0.025,1.484,0.681,0",
        "topics": "Suffrage, Women's Rights",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 58,
        "event": "Frederick Douglass dies suddenly of heart failure at age 77.",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1895,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Resolutions of Respect",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/mss11879.16003/?sp=1&r=-0.441,0.11,1.764,0.876,0",
        "topics": "Life Events, Frederick Douglass",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 57,
        "event": "Frederick Douglass is appointed U.S. minister resident and consul general, Republic of Haiti,",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1889,
        "location": "Port-Au-Prince, Haiti",
        "broaderLoc": ["Haiti"],
        "affiliatedPrimarySourcesNameAndDescription": "Frederick Douglass Papers: Speech, Article, and Book File: Haiti",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/mfd.27014/?sp=1",
        "topics": "Politics, Frederick Douglass",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 56,
        "event": "Harriet Tubman's second biography is published.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1886,
        "location": "Auburn, NY",
        "broaderLoc": ["New York"],
        "affiliatedPrimarySourcesNameAndDescription": "Harriet, the Moses of her people , [Front cover]",
        "affiliatedPrimarySourcesLink": "https://digitalcollections.nypl.org/items/b56654d0-b4b3-0138-b88e-035a4decd043",
        "topics": "Biography, Harriet Tubman",
        "sourceHyperlinkText": "From the New York Public Library",
        "centerThumbnail": true
    },
    {
        "id": 55,
        "event": "Clara Barton establishes the American Red Cross.",
        "year": 1881,
        "location": "DC",
        "broaderLoc": ["Washington, DC"],
        "topics": "Culture"
    },
    {
        "id": 54,
        "event": "Frederick Douglass publishes his third and final autobiography, The Life and Times of Frederick Douglass. ",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1881,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Chapter from Frederick Douglass's draft manuscript of his autobiography, Life and Times of Frederick Douglass",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/mcc.011/",
        "topics": "Biography, Frederick Douglass",
        "sourceHyperlinkText": "From the New York Public Library"
    },
    {
        "id": 53,
        "event": "Frederick Douglass is appointed U.S. marshal of the District of Columbia by President Hayes.",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1877,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Washington, D.C.--the new administration--colored citizens paying their respects to Marshall Frederick Douglass",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/cph.3b39466/",
        "topics": "Politics, Frederick Douglass",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 52,
        "event": "The 15th Amendment of the U.S. Constitution is ratified and grants African American men the right to vote.",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1870,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "\"The first vote\" / AW [monogram] ; drawn by A.R. Waud.",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/00651117/",
        "topics": "Amendments, Politics",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 51,
        "event": "Wyoming is the first state or territory in the United States that grants women the right to vote.",
        "year": 1869,
        "location": "Wyoming",
        "broaderLoc": ["Wyoming"],
        "topics": "Women's Rights, Suffrage"
    },
    {
        "id": 50,
        "event": "Scenes in the Life of Harriet Tubman by Sarah H. Bradford is published the same year Harriet Tubman marries Nelson Davis.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1869,
        "location": "Auburn, NY",
        "broaderLoc": ["New York"],
        "affiliatedPrimarySourcesNameAndDescription": "Scenes in the Life of Harriet Tubman",
        "affiliatedPrimarySourcesLink": "https://digitalcollections.nypl.org/items/dd44efe0-70bf-013a-b2ff-0242ac110003",
        "topics": "Biography, Life Events, Harriet Tubman",
        "sourceHyperlinkText": "From the New York Public Library"
    },
    {
        "id": 49,
        "event": "The 14th Amendment grants citizenship to \"all persons born or naturalized in the United States.\" ",
        "importantPeopleAssociates": [
            "Harriet Tubman",
            "Frederick Douglass"
        ],
        "year": 1868,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "14th Amendment to the U.S. Constitution: Civil Rights (1868)",
        "affiliatedPrimarySourcesLink": "https://www.archives.gov/milestone-documents/14th-amendment",
        "topics": "Amendments, Politics, Laws and Legal Cases",
        "sourceHyperlinkText": "National Archives"
    },
    {
        "id": 48,
        "event": "Congress enacts the Civil Rights Act of 1866. It was the first United States federal law to define citizenship and affirm that all citizens are equally protected by the law",
        "importantPeopleAssociates": [
            "Harriet Tubman",
            "Frederick Douglass"
        ],
        "year": 1866,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Glimpses at the Freedmen - The Freedmen's Union Industrial School, Richmond, Va. / from a sketch by Jas E. Taylor.",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/pictures/item/98501491/",
        "topics": "Civil Rights Act, Politics, Laws and Legal Cases",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 47,
        "event": "The Reconstruction Era lasts until 1877. Primary focus is to bring southern states into full participation in the Union, guarantee rights to formerly enslaved people, and define new relationships between African Americans and whites.",
        "year": 1865,
        "location": "American South",
        "broaderLoc": ["American South"],
        "affiliatedPrimarySourcesNameAndDescription": "Radical members of the first legislature after the war, South Carolina",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/ppmsca.30572/",
        "topics": "Politics"
    },
    {
        "id": 46,
        "event": "The Ku Klux Klan forms is founded.",
        "year": 1865,
        "location": "Pulaski, Tennessee",
        "broaderLoc": ["Tennessee"],
        "topics": "Culture"
    },
    {
        "id": 45,
        "event": "The 13th Amendment is ratified and abolishes slavery in the United States.",
        "importantPeopleAssociates": [
            "Frederick Douglass",
            "Harriet Tubman"
        ],
        "year": 1865,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Speech of Gen. Hiram Walbridge, on the proposed amendment to the federal Constitution forever prohibiting slavery",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/rbaapc.32700/?sp=4&st=text",
        "topics": "Laws and Legal Cases, Politics, Amendments",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 44,
        "event": "The Civil War ends when Confederate General Robert E. Lee surrenders to Union General Ulysses S. Grant. Five days later, President Abraham Lincoln is assassinated. ",
        "importantPeopleAssociates": [
            "Abraham Lincoln",
            "Frederick Douglass"
        ],
        "year": 1865,
        "location": "Washington, DC, Virginia",
        "broaderLoc": ["Washington, DC", "Virginia"],
        "affiliatedPrimarySourcesNameAndDescription": "Civil War campaigns of 1864",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/99447146/",
        "topics": "Civil War, Abraham Lincoln",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 43,
        "event": "The Emancipation Law of 1864 provides freedom for enslaved people living in Maryland. ",
        "year": 1864,
        "location": "Maryland",
        "broaderLoc": ["Maryland"],
        "topics": "Abolition, Slavery, Laws and Legal Cases"
    },
    {
        "id": 42,
        "event": "Frederick Douglass and Abraham Lincoln meet to discuss equality for Black soldiers.",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1864,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "\"Frederick Douglass appealing to President Lincoln and his cabinet to enlist Negroes,\" mural by William Edouard Scott",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/pictures/item/2010641714/",
        "topics": "Civil War, Frederick Douglass",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 41,
        "event": "The Combahee River Raid, led by Harriet Tubman and hundreds of Black Union soldiers, liberates 727 enslaved people.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1863,
        "location": "South Carolina",
        "broaderLoc": ["South Carolina"],
        "affiliatedPrimarySourcesNameAndDescription": "HARRIET TUBMAN: VISIONS OF FREEDOM ",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733302205?h=7e8ac86944\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Civil War, Harriet Tubman, Slavery",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 40,
        "event": "Congress passes the Conscription Act, resulting in the New York City Draft Riots.",
        "year": 1863,
        "location": "New York",
        "broaderLoc": ["New York"],
        "topics": "Laws and Legal Cases"
    },
    {
        "id": 39,
        "event": "President Lincoln issues the Emancipation Proclamation.",
        "importantPeopleAssociates": [
            "Abraham Lincoln"
        ],
        "year": 1863,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Emancipation Proclamation",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/rr/program/bib//ourdocs/emanproc.html",
        "topics": "Civil War, Politics",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 38,
        "event": "Clara Barton volunteers as a Civil War nurse, bringing medical services and supplies to the battlefield hospitals.",
        "year": 1861,
        "location": "Virginia",
        "broaderLoc": ["Virginia"],
        "topics": "Civil War"
    },
    {
        "id": 37,
        "event": "Inventors receive the first patent for prosthetic limbs.",
        "year": 1861,
        "location": "Meredith, New Hampshire",
        "broaderLoc": ["New Hampshire"],
        "topics": "Inventions"
    },
    {
        "id": 36,
        "event": "Harriet Tubman serves in the Civil War through many roles, including as a spy and nurse.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1861,
        "location": "Underground Railroad, South Carolina",
        "broaderLoc": ["South Carolina"],
        "affiliatedPrimarySourcesNameAndDescription": "HARRIET TUBMAN: VISIONS OF FREEDOM \"General Tubman\"",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733302131?h=fb1e799cc1\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Civil War, harriet Tubman"
    },
    {
        "id": 35,
        "event": "Harriet Tubman completes her last mission on the Underground Railroad.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1860,
        "location": "MD to Canada",
        "broaderLoc": ["Maryland", "Canada"],
        "affiliatedPrimarySourcesNameAndDescription": "HARRIET TUBMAN: VISIONS OF FREEDOM \"Underground Railroad\"",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733302066?h=4ce612e084\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Underground Railroad, Harriet Tubman",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 34,
        "event": "Abraham Lincoln is elected as the 16th President of the U.S.",
        "importantPeopleAssociates": [
            "Abraham Lincoln"
        ],
        "year": 1860,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Photo card, Abraham Lincoln",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/mal.4500035/?sp=1&r=-0.293,0.2,1.486,0.738,0",
        "topics": "Politics",
        "sourceHyperlinkText": "Library of Congress",
        "centerThumbnail": true
    },
    {
        "id": 33,
        "event": "John Brown leads the raid on Harpers Ferry to protest slavery. Frederick Douglass flees to Canada and England to avoid association with Brown.",
        "importantPeopleAssociates": [
            "John Brown",
            "Frederick Douglass"
        ],
        "year": 1859,
        "location": "Harper's Ferry, WV, Canada, Europe",
        "broaderLoc": ["West Virginia", "Canada", "Europe"],
        "affiliatedPrimarySourcesNameAndDescription": "[John Brown's fort, Harpers Ferry, West Virginia] ",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/ppmsca.40573/",
        "topics": "Harper's Ferry, Frederick Douglass, Abolition",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 32,
        "event": "The Supreme Court rules on the Dred Scott v. Sandford case. The Court states that African Americans are not U.S. citizens and that Congress has no authority to restrict slavery in U.S. territories.",
        "year": 1857,
        "location": "Illinois, Missouri, Washington, DC",
        "broaderLoc": ["Illinois", "Missouri", "Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "Eliza and Lizzie, children of Dred Scott Dred Scott ; His wife, Harriet.",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/2002707034/",
        "topics": "Dred Scott, Laws and Legal Cases, Politics",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 31,
        "event": "Frederick Douglass publishes his second autobiography.",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1855,
        "location": "New York",
        "broaderLoc": ["New York"],
        "affiliatedPrimarySourcesNameAndDescription": "My Bondage and My Freedom.",
        "affiliatedPrimarySourcesLink": "https://digitalcollections.nypl.org/items/ea626bd0-2189-0132-2764-58d385a7bbd0",
        "topics": "Biography, Frederick Douglass",
        "sourceHyperlinkText": "From the New York Public Library"
    },
    {
        "id": 30,
        "event": "Harriet Beecher Stowe publishes Uncle Tom's Cabin, an anti-slavery novel. ",
        "importantPeopleAssociates": [
            "Harriet Beecher Stowe"
        ],
        "year": 1852,
        "location": "Boston, MA",
        "broaderLoc": ["Massachusetts"],
        "affiliatedPrimarySourcesNameAndDescription": "Image 15 of Uncle Tom's cabin",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/gdcmassbookdig.uncletomscabin00stow_2/?sp=15",
        "topics": "Uncle Tom's Cabin, The Pearl Incident",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 29,
        "event": "Frederick Douglass breaks from his mentor to advocate for political, and even violent, solutions to end slavery.",
        "importantPeopleAssociates": [
            "Frederick Douglass",
            "William Lloyd Garrison"
        ],
        "year": 1852,
        "location": "New Bedford, MA",
        "broaderLoc": ["Massachusetts"],
        "affiliatedPrimarySourcesNameAndDescription": "Frederick Douglass, the escaped slave, on an English platform, denouncing slaveholders and their religious abettors",
        "affiliatedPrimarySourcesLink": "https://digitalcollections.nypl.org/items/510d47da-74f5-a3d9-e040-e00a18064a99",
        "topics": "Abolition, Politics, Frederick Douglass",
        "sourceHyperlinkText": "From the New York Public Library"
    },
    {
        "id": 28,
        "event": "The New York Times newspaper is founded.",
        "year": 1851,
        "location": "New York",
        "broaderLoc": ["New York"],
        "topics": "Culture"
    },
    {
        "id": 27,
        "event": "Tubman is forced to reroute her Underground Railroad route after the Fugitive Slave Act is passed.",
        "importantPeopleAssociates": [
            "Harriet Tubman",
            "William Still"
        ],
        "year": 1850,
        "location": "MD to Canada",
        "broaderLoc": ["Maryland", "Canada"],
        "affiliatedPrimarySourcesNameAndDescription": "HARRIET TUBMAN: VISIONS OF FREEDOM \"Original Abolitionists\"",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733301935?h=4802e2ad64\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Underground Railroad, Fugitive Slave Act, Harriet Tubman, Slavery",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 26,
        "event": "Harriet Tubman completes her first trip as a guide on the Underground Railroad.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1850,
        "location": "MD to PA",
        "broaderLoc": ["Maryland", "Pennsylvania"],
        "affiliatedPrimarySourcesNameAndDescription": "The underground railroad",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/pictures/item/98510370/",
        "topics": "Underground Railroad, Slavery, Harriet Tubman",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 25,
        "event": "The Associated Press is formed.",
        "year": 1849,
        "location": "Chicago --> NY",
        "broaderLoc": ["Illinois", "New York"],
        "topics": "Culture"
    },
    {
        "id": 24,
        "event": "Harriet Tubman escapes the plantation where she was enslaved after an earlier failed attempt with two brothers. Tubman escapes to freedom in Philadelphia, PA. ",
        "importantPeopleAssociates": [
            "Harriet Tubman",
            "William Still"
        ],
        "year": 1849,
        "location": "Dorchester County, MD, Philadelphia, PA",
        "broaderLoc": ["Maryland", "Pennsylvania"],
        "affiliatedPrimarySourcesNameAndDescription": "HARRIET TUBMAN: VISIONS OF FREEDOM \"Escape to Freedom\"",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733301815?h=489bdf4e53\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Slavery, Harriet Tubman, Life Events",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 23,
        "event": "The Treaty of Guadalupe Hidalgo officially ends the Mexican-American War after two years of fighting. ",
        "year": 1848,
        "location": "Arizona, California, Colorado, Nevada, New Mexico, Utah and Wyoming",
        "broaderLoc": ["Arizona", "California", "Colorado", "Nevada", "New Mexico", "Utah", "Wyoming"],
        "affiliatedPrimarySourcesNameAndDescription": "Mapa de los Estados Unidos de Méjico",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/g4410.ct008412/?r=0.167,-0.002,0.867,0.43,0",
        "topics": "War",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 22,
        "event": "The first Women’s Rights Convention is held in Seneca Falls, NY. Frederick Douglass attends.",
        "importantPeopleAssociates": [
            "Elizabeth Cady Stanton"
        ],
        "year": 1848,
        "location": "Seneca Falls, NY",
        "broaderLoc": ["New York"],
        "affiliatedPrimarySourcesNameAndDescription": "Report of the Woman's Rights Convention, held at Seneca Falls, New York, July 19th and 20th, 1848",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/rbcmil.scrp4006702/?sp=4",
        "topics": "Suffrage, Women's Rights",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 21,
        "event": "Seventy-seven enslaved African Americans attempt to escape Washington, D.C. on the Pearl schooner. The event later inspires the writing of Uncle Tom's Cabin.",
        "importantPeopleAssociates": [
            "Harriet Beecher Stowe"
        ],
        "year": 1848,
        "location": "Washington, DC",
        "broaderLoc": ["Washington, DC"],
        "affiliatedPrimarySourcesNameAndDescription": "United States slave trade, 1830",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/ds.13992/",
        "topics": "The Pearl Incident, Slavery, Uncle Tom's Cabin",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 20,
        "event": "Jefferson Davis is appointed to fill vacant the US Senate seat for Mississippi. He later serves as the president of the Confederate States from 1861 to 1865.",
        "year": 1847,
        "location": "Washington DC, Mississippi",
        "broaderLoc": ["Washington, DC", "Mississippi"],
        "topics": "Politics, Civil War"
    },
    {
        "id": 19,
        "event": "Frederick Douglass publishes the first issue of <i>The North Star</i>, his anti-slavery newspaper, to \"promote the moral and intellectual improvement of the colored people.\"",
        "importantPeopleAssociates": [
            "Frederick Douglass",
            "Mary Ann Shadd Cary"
        ],
        "year": 1847,
        "location": "Rochester, NY",
        "broaderLoc": ["New York"],
        "affiliatedPrimarySourcesNameAndDescription": "Image 1 of <i>The North Star</i> (Rochester, N.Y.), December 3, 1847",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/sn84026365/1847-12-03/ed-1/?sp=1&r=-0.348,-0.225,1.402,0.696,0",
        "topics": "Frederick Douglass, Abolition",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 18,
        "event": "The African Methodist Church celebrates its 40th anniversary with 296 churches and over 17,000 members.",
        "year": 1846,
        "location": "Philadelphia, PA",
        "broaderLoc": ["Pennsylvania"],
        "topics": "Culture"
    },
    {
        "id": 17,
        "event": "Frederick Douglass travels to Great Britain and Ireland. English supporters negotiate his manumission, and purchase his legal release from slavery. ",
        "importantPeopleAssociates": [
            "Frederick Douglass",
            "William Lloyd Garrison"
        ],
        "year": 1845,
        "location": "Ireland, Scotland, England",
        "broaderLoc": ["Ireland", "Scotland", "England"],
        "affiliatedPrimarySourcesNameAndDescription": "Frederick Douglass Papers: General Correspondence, 1841-1912; 1841, 1845",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/mss11879.03001/?sp=19&r=-0.084,-0.008,1.288,0.639,0",
        "topics": "Abolition",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 16,
        "event": "Frederick Douglass publishes his first autobiography.",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1845,
        "location": "Lynn, MA",
        "broaderLoc": ["Massachusetts"],
        "affiliatedPrimarySourcesNameAndDescription": "Narrative of the life of Frederick Douglass, an American slave\n",
        "affiliatedPrimarySourcesLink": "https://digitalcollections.nypl.org/items/f2caf3f0-0a87-0130-2bbb-58d385a7b928",
        "topics": "Biography, Frederick Douglass, Slavery",
        "sourceHyperlinkText": "From the New York Public Library"
    },
    {
        "id": 15,
        "event": "Samuel Morse sends first telegraph transmission from Washington to Baltimore, which reads: \"What hath God wrought?\"",
        "year": 1844,
        "location": "Washington, DC & Baltimore, MD",
        "broaderLoc": ["Washington, DC", "Maryland"],
        "topics": "Inventions"
    },
    {
        "id": 14,
        "event": "Araminta Ross marries a free Black man named John Tubman. She later changes her first name to Harriet, after her mother.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1844,
        "location": "Dorchester County, MD",
        "broaderLoc": ["Maryland"],
        "affiliatedPrimarySourcesNameAndDescription": "HARRIET TUBMAN: VISIONS OF FREEDOM",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733301760?h=65bc895be1\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Life Events, Harriet Tubman",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 13,
        "event": "New technologies for mass printing electrotype (1841) and rotary drum (1843) are invented. ",
        "year": 1841,
        "location": "New York, Paris",
        "broaderLoc": ["New York", "France"],
        "topics": "Inventions"
    },
    {
        "id": 12,
        "event": "Frederick Douglass becomes an orator for the Massachusetts Anti-Slavery Society. He tours the country as a speaker for the abolition of slavery",
        "importantPeopleAssociates": [
            "Frederick Douglass",
            "William Lloyd Garrison"
        ],
        "year": 1841,
        "location": "Nantucket, MA",
        "broaderLoc": ["Massachusetts"],
        "affiliatedPrimarySourcesNameAndDescription": "BECOMING FREDERICK DOUGLASS \"Extended Trailer' ",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/678000021?h=d74672319c\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Abolition, Antislavery Society, Frederick Douglass",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS",
        "centerThumbnail": true
    },
    {
        "id": 11,
        "event": "Atlantic steamboats begin to cross the Atlantic.",
        "year": 1838,
        "location": "US to Europe",
        "broaderLoc": ["United States", "Europe"],
        "topics": "Inventions"
    },
    {
        "id": 10,
        "event": "Frederick Bailey meets Anna Murray, a free Black woman. She helps him plan an escape. He borrows the papers of a free Black sailor, and successfully escapes slavery to New York. ",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1838,
        "location": "Baltimore, MD",
        "broaderLoc": ["Maryland"],
        "affiliatedPrimarySourcesNameAndDescription": "BECOMING FREDERICK DOUGLASS: \"Anna Murray\"",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733314630?h=6d32290bec\" width=\"640\" height=\"480\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Frederick Douglass, Slavery",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 9,
        "event": "Araminta Ross suffers a severe head injury when she is hit by a weight thrown at an enslaved boy.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1833,
        "location": "Dorchester County, MD",
        "broaderLoc": ["Maryland"],
        "affiliatedPrimarySourcesNameAndDescription": "HARRIET TUBMAN: VISIONS OF FREEDOM \"Visions\"",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733301651?h=6c65a629f8\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Life Events, Slavery, Harriet Tubman",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 8,
        "event": "Nat Turner’s Rebellion leads both to stronger prohibitions against Black literacy and more formal organization of the Underground Railroad.",
        "importantPeopleAssociates": [
            "Nat Turner"
        ],
        "year": 1831,
        "location": "Southampton County, VA",
        "broaderLoc": ["Virginia"],
        "affiliatedPrimarySourcesNameAndDescription": "The confessions of Nat Turner, the leader of the late insurrection in Southampton, Va.",
        "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/07009643/",
        "topics": "Nat Turner, Slavery, Underground Railroad",
        "sourceHyperlinkText": "Library of Congress"
    },
    {
        "id": 7,
        "event": "The Trail of Tears (1830-1850) forces the displacement of approximately 60,000 Native Americans.",
        "year": 1830,
        "location": "Southern United States --> West of Mississippi River",
        "broaderLoc": ["United States", "Mississippi"],
        "topics": "Politics"
    },
    {
        "id": 6,
        "event": "Boston abolitionist David Walker publishes “Appeal to the Colored Citizens of the World.” Walker encourages enslaved people to fight for their freedom.",
        "year": 1829,
        "location": "Boston, MA",
        "broaderLoc": ["Massachusetts"],
        "topics": "Abolition"
    },
    {
        "id": 5,
        "event": "Louis Daguerre invents daguerreotype, the first form of modern photography. ",
        "year": 1826,
        "location": "Burgundy, France, England",
        "broaderLoc": ["France", "England"],
        "topics": "Inventions"
    },
    {
        "id": 4,
        "event": "Frederick Bailey is sent to Baltimore to work for Hugh and Sophia Auld. ",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1826,
        "location": "Baltimore, MD",
        "broaderLoc": ["Maryland"],
        "affiliatedPrimarySourcesNameAndDescription": "BECOMING FREDERICK DOUGLASS\n\"Young Frederick\"",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/714241314?h=264379a30e\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Life Events, Slavery, Frederick Douglass",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 3,
        "event": "Araminta Ross is born is born into slavery on the Eastern Shore of Maryland.",
        "importantPeopleAssociates": [
            "Harriet Tubman"
        ],
        "year": 1820,
        "location": "Dorchester County, MD",
        "broaderLoc": ["Maryland"],
        "affiliatedPrimarySourcesNameAndDescription": "HARRIET TUBMAN: VISIONS OF FREEDOM \"The Eastern Shore\"",
        "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/733301556?h=c15eb09e70\" width=\"640\" height=\"360\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>",
        "topics": "Life Events, Slavery, Harriet Tubman",
        "sourceHyperlinkText": "MPT | Firelight Films | PBS"
    },
    {
        "id": 2,
        "event": "The Flag Act of 1818 establishes the flag of the United States. It is still honored today.",
        "year": 1818,
        "location": "Somerville, MA",
        "broaderLoc": ["Maryland"],
        "topics": "Politics"
    },
    {
        "id": 1,
        "event": "Frederick Augustus Washington Bailey is born into slavery on the Eastern Shore of Maryland.",
        "importantPeopleAssociates": [
            "Frederick Douglass"
        ],
        "year": 1818,
        "location": "Talbot County, MD",
        "broaderLoc": ["Maryland"],
        "affiliatedPrimarySourcesNameAndDescription": "Studio portrait of Frederick Douglass",
        "affiliatedPrimarySourcesLink": "https://digitalcollections.nypl.org/items/82c9f300-9980-0139-aa81-0242ac110003",
        "topics": "Life Events, Slavery, Frederick Douglass",
        "sourceHyperlinkText": "Library of Congress",
        "centerThumbnail": true
    }
]
}

export default data;